@if (user) {
  <span class="flex min-w-0 items-center gap-2">
    <app-avatar [url]="user.avatarUrl" [title]="user.name" [size]="size" [isPhotoGallery]="false" />
    <span class="min-w-0 truncate" [class.text-slate-400]="!user.isActive" [title]="user.name">{{ user.name }}</span>
  </span>
} @else {
  <span class="text-slate-300">—</span>
}
